export default __webpack_public_path__ + "static/media/sell.9e849ca8.svg";